import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router'
import { useGetMenuItemByIdQuery } from '../Apis/menuItemApi';
import { useUpdateShoppingCartMutation } from '../Apis/shoppingCartApi';
import { MainLoader, MiniLoader } from '../Components/Page/Common';
import { toastNotify } from '../Helper';
import { apiResponse, userModel } from '../Interfaces';
import { RootState } from '../Storage/Redux/store';

function MenuItemDetails() {
  const nav = useNavigate();
  const {menuItemId} = useParams();
  const {data, isLoading} = useGetMenuItemByIdQuery(menuItemId)
  const [quantity, setQuantity] = useState(1);
  const [isAddingToCart, setAddingToCart]= useState<boolean>(false);
  const [updateShoppingCart] = useUpdateShoppingCartMutation();  


  const handleQuantity = (counter: number)=>{
    let newQuantity = quantity+ counter
    if(newQuantity === 0)
      newQuantity = 1;
      setQuantity(newQuantity)
    return;
  }

  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );

  const handleAddToCart = async (menuItemId:number)=>{
    if(sessionStorage.getItem("token")===null)
       {
        toastNotify("Please Login !!!","error")
        nav("/login")
        return 
       }
    setAddingToCart(true)

   const r : apiResponse= await updateShoppingCart({
      menuItemId: menuItemId,
      updateQuantityBy: quantity,
      userId: userData.id
    })
    if (r.data && r.data.isSuccess) {
      toastNotify("Item added to cart successfully!");
    }

    setAddingToCart(false)
  }

  return (
    <>
    <div className="container pt-4 pt-md-5 d-none d-md-block d-lg-block d-xl-block">
      {!isLoading? (
      <>
      <div className="row">
        <div className="col-7">
          <h2 className="text-success">{data.result.name}</h2>
          <span>
            <span
              className="badge text-bg-dark pt-2"
              style={{ height: "40px", fontSize: "20px" }}
            >
              {data.result.category}
            </span>
          </span>
          <span>
            <span
              className="badge text-bg-light pt-2"
              style={{ height: "40px", fontSize: "20px" }}
            >
              {data.result.specialTag}
            </span>
          </span>
          <p style={{ fontSize: "20px" }} className="pt-2">
            {data.result.description}
          </p>
          <span className="h3">&#x20b9; {data.result.price}</span> &nbsp;&nbsp;&nbsp;
          <span
            className="pb-2  p-3"
            style={{ border: "1px solid #333", borderRadius: "30px" }}
          >
            <i onClick={()=>handleQuantity(-1)}
              className="bi bi-dash p-1"
              style={{ fontSize: "25px", cursor: "pointer" }}
            ></i>
            <span className="h3 mt-3 px-3">{quantity}</span>
            <i onClick={()=>handleQuantity(+1)}
              className="bi bi-plus p-1"
              style={{ fontSize: "25px", cursor: "pointer" }}
            ></i>
          </span>
          <div className="row pt-4">
            <div className="col-5">
              {isAddingToCart? (
                <>
                 <button disabled className="btn btn-success form-control">
                    <MiniLoader />
                  </button>
                </>
              ): (
                <>
                <button className="btn btn-success form-control"
                onClick={()=>handleAddToCart(data.result.id)}>
                Add to Cart
              </button>
                </>
              )}
            </div>

            <div className="col-5 ">
              <button className="btn btn-secondary form-control"
              onClick={()=> nav(-1)}>
                Back to Home
              </button>
            </div>
          </div>
        </div>
        <div className="col-5">
          <img
            src= {data.result.image}
            width="100%"
            style={{ borderRadius: "10%" }}
            alt="No content"
          ></img>
        </div>
      </div>
      </>
      ):
      (<>
      <div className='d-flex justify-content-center' style={{width: "100%"}}>
        <MainLoader/>
      </div>
      </>)}
    </div>
    <div className="container pt-4 pt-md-5 d-block d-md-none d-lg-none d-xl-none">
      {!isLoading? (
      <>
          <img
            src= {data.result.image}
            width="100%"
            style={{ borderRadius: "10%" }}
            alt="No content"
          ></img>
          <h2 className="text-success text-center mt-3">{data.result.name}</h2>
          <h2 className="text-success text-center mt-1">&#x20b9; {data.result.price}</h2>
          <span className='d-flex justify-content-center'>
            <span
              className="badge text-bg-dark pt-2"
              style={{ height: "40px", fontSize: "20px"}}
            >
              {data.result.category}
            </span>
          </span>
          <span className='d-flex justify-content-center'>
            <span
              className="badge text-bg-light pt-2"
              style={{ height: "40px", fontSize: "20px"}}
            >
              {data.result.specialTag}
            </span>
          </span>
          <p style={{ fontSize: "20px" }} className="pt-2">
            {data.result.description}
          </p>
          <div style={{marginLeft: "28%"}}>
          <span
            className="pb-2  p-3"
            style={{ border: "1px solid #333", borderRadius: "30px" }}
          >
            <i onClick={()=>handleQuantity(-1)}
              className="bi bi-dash p-1"
              style={{ fontSize: "25px", cursor: "pointer" }}
            ></i>
            <span className="h3 mt-3 px-3">{quantity}</span>
            <i onClick={()=>handleQuantity(+1)}
              className="bi bi-plus p-1"
              style={{ fontSize: "25px", cursor: "pointer" }}
            ></i>
          </span>
          </div>
          <div className="row pt-4 d-flex justify-content-center mb-4">
            <div className="col-5">
            <button className="btn btn-secondary form-control"
              onClick={()=> nav(-1)}>
                <i className="bi bi-skip-backward-fill"></i>
              </button>
            </div>

            <div className="col-5 ">
            {isAddingToCart? (
                <>
                 <button disabled className="btn btn-success form-control">
                    <MiniLoader />
                  </button>
                </>
              ): (
                <>
                <button className="btn btn-success form-control"
                onClick={()=>handleAddToCart(data.result.id)}>
                  <i className="bi bi-cart-plus"></i>
              </button>
                
                </>
              )}
            
            </div>
          </div>
      </>
      ):
      (<>
      <div className='d-flex justify-content-center' style={{width: "100%"}}>
        <MainLoader/>
      </div>
      </>)}
    </div>
    </>
  )
}

export default MenuItemDetails